export default "__VITE_ASSET__DvagVPa2__"